import { render, staticRenderFns } from "./ShortlistBooks.vue?vue&type=template&id=6ea43912&"
import script from "./ShortlistBooks.vue?vue&type=script&lang=js&"
export * from "./ShortlistBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports